/**
 * The Anser panel is suppressed only on the full-page chat, which owns the
 * conversation there; every other Coach page (`/coach/teams`, …) keeps it.
 * Shared by the panel itself and the header toggle so they never disagree.
 */
export function isRailSuppressed(pathname: string): boolean {
  return pathname === "/coach";
}
